<app-widget-home-core
  [widget]="widget"
  [isStoreView]="isStoreView"
  [subheader]="local"
  (click)="onClickWidget()"
>

  <app-widget-principal-data
    [label]="'WIDGETS.HOME.COMMUNICATION.PENDENTS_BREAKDOWNS' | translate"
    [data]="widgetData"
    [showData]="loadedData || isStoreView"
  ></app-widget-principal-data>

</app-widget-home-core>
